import { IconLayer } from '@deck.gl/layers/typed';
import { Port } from 'ais-facade-api/api';
import { useGetPortsMutation } from 'app/api/marine-infrastructure';
import { svgToDataURL } from 'app/helpers';
import { getPortIcon } from 'helpers/getWebGLPointIcon';
import { useAppDispatch, useAppSelector } from 'app/store/store';
import { setPortsOnMap } from 'app/utils/facadeReducer';
import { setHoveredTarget } from 'app/utils/mapStateSlice';
import { setSelectedTarget } from 'app/utils/selectedTargetsSlice';
import { useEffect } from 'react';

export const useLayerPorts = (viewState: any, showPorts: boolean) => {
  const mode = useAppSelector((state) => state.mapStateSlice.mode);
  const isAnalyticsMode = mode === 'analytics';
  const ports = useAppSelector((state) => state.facadeSlice.portsOnMap);
  const rulerOn = useAppSelector((state) => state.mapStateSlice.tools.ruler);

  const [, { data: portsResponse, ...portsRequest }] = useGetPortsMutation({
    fixedCacheKey: 'get-map-ports',
  });

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (portsResponse?.results && portsRequest.isSuccess) {
      dispatch(setPortsOnMap(portsResponse?.results));
    }
  }, [portsRequest]);

  const layerPorts = new IconLayer({
    id: 'layer-ports',
    data: ports,
    pickable: true,

    getPosition: (d: Port): [number, number, number] => {
      if (typeof d?.lon === 'number' && typeof d?.lat === 'number') return [d.lon, d.lat, 0];
      return [999, 999, 10];
    },

    getAngle: (d) => {
      return -d.heading || -d.cog;
    },
    getIcon: () => ({
      url: svgToDataURL(getPortIcon()),
      width: 32,
      height: 32,
    }),

    onClick(pickingInfo) {
      if (rulerOn) return;

      dispatch(setSelectedTarget({ target: pickingInfo, type: 'port' }));
    },
    onHover(pickingInfo) {
      dispatch(setHoveredTarget(pickingInfo));
    },

    sizeMinPixels: 32,
    autoHighlight: true,
    visible: viewState.zoom > 6 && showPorts && !isAnalyticsMode,
  });
  return layerPorts;
};
